import { AddTrainingPayload } from "../../../../models/Training";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allTrainingKey } from "../../queries/Training/useFetchAllTraining";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addTraining(data: AddTrainingPayload) {
  const res = await ApiClient.post(`/AddTraining`, data);
  return res.data;
}

export const useAddTraining = mutationWrapper(addTraining, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allTrainingKey);
  },
});
